/**
 * 将路径图片转换为base64
 * @param url 图片的静态路径
 * @param coef 图片质量系数
 */
export const base64TransformByURL = (url, coef) => {
    function getBase64Image(img) {
        let canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, img.width, img.height)
        // let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
        let base64 = canvas.toDataURL('image/jpg', coef).split(',')[1]
        return base64
    }
    return new Promise((resolve, reject) => {
        const image = new Image()
        image.crossOrigin = 'anonymous'
        image.onload = () => {
            resolve(getBase64Image(image))
        }
        image.src = url
    })
}

/**
 * 将上传的文件转换成base64 返回，目前仅支持单文件
 * @param file
 */

// export const base64TransformByFile = async (file) => {
//     return new Promise((resolve, reject) => {
//         const oReader = new FileReader()
//         oReader.onload = async (e) => {
//             resolve(await base64TransformByURL(e.target.result))
//         }
//         oReader.readAsDataURL(file)
//     })
// }
